export default {
  mounted(el) {
    let $input = el;

    if ($input.tagName !== 'INPUT') {
      $input = el.querySelector('input');
    }

    $input.focus();
  },
};
